import { FC, ReactNode, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@getgo/chameleon-web-react-wrapper';

import EtrustIcon from 'assets/trustarc.svg';
import { useAppSelector } from 'hooks';
import { sessionInvoiceNumber } from 'modules/session-details';
import st from 'utils/shared-translations';

import './footer.css';

interface FooterProps {
  showFooterText?: boolean;
}

const Footer: FC<FooterProps> = ({ showFooterText = true }): JSX.Element => {
  const [isFooterTextVisible, setFooterTextVisible] = useState(false);

  const selectedInvoiceNumber = useAppSelector(sessionInvoiceNumber);

  useEffect(() => {
    // Hide footer text if invoice number is present
    if (selectedInvoiceNumber) {
      setFooterTextVisible(false);
    } else {
      setFooterTextVisible(true);
    }
  }, [selectedInvoiceNumber]);

  return (
    <div className="footer" data-testid="footer">
      {isFooterTextVisible && showFooterText && (
        <Typography variant="caption-medium" color="type-color-secondary">
          <FormattedMessage
            {...st['payment.tnc']}
            values={{
              'tos-link': (msg: ReactNode) => (
                <a
                  href="https://www.goto.com/company/legal/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography tag="span" variant="body-small" color="link">
                    {msg}
                  </Typography>
                </a>
              ),
              'privacy-policy': (msg: ReactNode) => (
                <a href="https://www.goto.com/company/legal/privacy" target="_blank" rel="noopener noreferrer">
                  <Typography tag="span" variant="body-small" color="link">
                    {msg}
                  </Typography>
                </a>
              ),
              'anti-spam': (msg: ReactNode) => (
                <a href="https://www.goto.com/company/legal/anti-spam-policy" target="_blank" rel="noopener noreferrer">
                  <Typography tag="span" variant="body-small" color="link">
                    {msg}
                  </Typography>
                </a>
              ),
            }}
          />
        </Typography>
      )}
      <a
        href="https://privacy.truste.com/privacy-seal/validation?rid=2853fc28-1c77-46f4-8ff8-e4289f5e569b"
        target="_blank"
        rel="noopener noreferrer"
      >
        <EtrustIcon />
      </a>
    </div>
  );
};

export default Footer;
